// Muhasebe — paylaşılan yardımcılar. Monolit Accounting.js bölündü (alt sekmeler ayrı dosyalarda).
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

export const isoDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function presetRange(key) {
  const n = new Date(); const y = n.getFullYear(), m = n.getMonth(), d = n.getDate();
  if (key === "today") return [isoDate(new Date(y, m, d)), isoDate(new Date(y, m, d))];
  if (key === "week") return [isoDate(new Date(y, m, d - 6)), isoDate(new Date(y, m, d))];
  if (key === "lastmonth") return [isoDate(new Date(y, m - 1, 1)), isoDate(new Date(y, m, 0))];
  if (key === "year") return [isoDate(new Date(y, 0, 1)), isoDate(new Date(y, 11, 31))];
  return [isoDate(new Date(y, m, 1)), isoDate(new Date(y, m + 1, 0))];
}

export const EXP_CATS = ["Kira", "Elektrik", "Su", "Doğalgaz", "Personel/Maaş", "SGK Primi", "Vergi/Harç", "Nakliye/Lojistik", "Yakıt", "Araç Bakım/Onarım", "Depo Gideri", "Mağaza Gideri", "Kırtasiye", "Bakım/Onarım", "Temizlik", "Güvenlik", "Sigorta", "Ambalaj/Poşet", "Pazarlama/Reklam", "Pazaryeri Komisyonu", "Banka/POS Masrafı", "Yazılım/Abonelik", "İletişim/Telefon", "Danışmanlık", "Diğer"];
export const INC_CATS = ["Kira Geliri", "Faiz Geliri", "Komisyon Geliri", "Hurda/İkinci El Satışı", "Kur Farkı Geliri", "İade/İskonto Geliri", "Diğer Gelir"];
export const ACC_LABEL = { cash: "Nakit", bank: "Banka", credit: "Açık/Kredi", cek: "Çek", senet: "Senet" };

export const Kpi = ({ label, value, sub, Icon, accent = "text-slate-900", testid }) => (
  <div data-testid={testid} className="rounded-md bg-white p-4 ring-1 ring-inset ring-slate-200">
    <div className="mb-1 flex items-center justify-between"><p className="overline">{label}</p><Icon className="h-4 w-4 text-slate-300" /></div>
    <p className={`tabular font-heading text-2xl font-bold ${accent}`}>{value}</p>
    {sub && <p className="mt-0.5 text-xs text-slate-400">{sub}</p>}
  </div>
);

export const StmtRow = ({ label, value, strong, accent, indent }) => (
  <div className={`flex items-center justify-between py-2 text-sm ${strong ? "border-t border-slate-200 font-semibold" : ""} ${indent ? "pl-4 text-slate-500" : "text-slate-700"}`}>
    <span>{label}</span><span className={`tabular ${accent || (strong ? "text-slate-900" : "text-slate-700")} ${strong ? "font-bold" : ""}`}>{value}</span>
  </div>
);

// Canlı (piyasa) döviz kurunu getirip forma yazan buton — fatura/kayıt formlarında yeniden kullanılır.
export const fetchLiveFxRate = async (currency) => {
  const { data } = await api.get("/accounting/fx-rate", { params: { currency } });
  return data;
};

export function LiveFxButton({ currency, onRate, testid = "live-fx-btn" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const d = await fetchLiveFxRate(currency);
      onRate(d.rate);
      toast.success(`Güncel kur: 1 ${currency} = ${d.rate} ₺ (${d.source})`);
    } catch { toast.error("Canlı kur alınamadı"); }
    finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid={testid} onClick={run} disabled={busy}
      title="Canlı piyasa kurunu getir (1 birim = ? ₺)"
      className="inline-flex h-8 shrink-0 items-center gap-1 rounded-md border border-brand-green/40 bg-brand-green/5 px-2 text-[11px] font-semibold text-brand-green hover:bg-brand-green/10 disabled:opacity-60">
      <RefreshCw className={`h-3 w-3 ${busy ? "animate-spin" : ""}`} /> Canlı Kur
    </button>
  );
}
